<template>
    <div v-if="status">
        <IndependentAcceleratorsView />
        <ReportTemplate :table-props="kafkaColumns" :project-param-id="projectParamId" :jms-param-id="jmsParamId" />
    </div>
</template>

<script>
import ReportTemplate from "@/components/ReportTemplate.vue";
import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import IndependentAcceleratorsView from "./IndependentAcceleratorsView.vue";

export default {
    name: pageViews.KAFKACONFIGGENERATORVIEW,
    methods: {
        setValuesToStore(type) {
            Store.commit("setType", type);
        },
    },
    mounted() {
        this.setValuesToStore(type.KAFKA);
    },
    components: {
      ReportTemplate,
      IndependentAcceleratorsView
    },
    data() {
        return {
        status: true,
        uploadConfigs: {
            action: "generator",
            actionLabel: "Generator",
            title: "Kafka Config Generator",
            type: type.KAFKA,
            accept: ".zip",
        },
        kafkaColumns: {
            type: type.KAFKA,
            isMultiSelectionAllowed: true,
            configs: [
            {
              name: "jmsId",
              label: "JMS ID",
              order: 2,
            },
            {
                name: "requestDate",
                label: "Request Date",
                order: 1,
                type: "date",
                search: false,
                defaultSelected: true
            },
            {
                name: "fileName",
                label: "File Name",
                order: 4,
                checked: true,
                defaultSelected: true,
                textAlign: "left",
            },
            {
                name: "status",
                label: "Status",
                order: 5,
                isSortable: false,
                defaultSelected: true,
                search: false
            },
            {
                name: "lastModifiedDate",
                label: "Last Modified Date",
                order: 6,
                type: "date",
                search: false
            },
            {
                name: "topicCount",
                label: "No. of Topics",
                order: 7,
                search: false,
                defaultSelected: true
            },
            {
                name: "queueCount",
                label: "No. of Queues",
                order: 8,
                search: false,
                defaultSelected: true
            },
            {
                name: "totalTopics",
                label: "Total Queues & Topics",
                order: 9,
                search: false,
            },
            // {
            //     name: "duplicateTopics",
            //     label: "Duplicate Queues & Topics",
            //     order: 10,
            //     search: false,
            // },
            {
                name: "failCount",
                label: "No. of Failed Topics",
                order: 10,
                search: false,
            },
            {
                name: "failedTopics",
                label: "Failed Topics",
                order: 11,
                search: false,
                textAlign: "left",
                textOverflowStyle: "ellipsis",
            },
            {
                name: "remarks",
                label: "Remarks",
                order: 12,
                search: false,
                textAlign: "left",
                textOverflowStyle: "ellipsis",
                isSortable: false
            }
            ],
            actions: {
            view: {
                label: 'View Output',
                popupTitle:'Kafka Topic Configuration'
            },
            download: {
                label: 'Request Download'
            },
            }
        }  
        };
    },
    props: ["projectParamId", "jmsParamId"],
}

</script>
